import { useMemo } from 'react';

import { useBetSlice } from '@pp/core/src/store/slices/bets/selectors';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { GameStatus } from '@pp/core/src/store/slices/game/types';

import { useHighflyerStateSlice } from '../../../store/slices/highflyerState/selectors';

import { useIsBetConfirmedConnected } from './useIsBetConfirmedConnected';

export const useBetStepperDisabled = (betCode: number): boolean => {
  const currentStatus = useGameStateSlice.getCurrentStatus();
  const betLimits = useBetSlice.betLimits() ?? {};
  const betMinLimit = betLimits[betCode].min;
  const isBetConfirmed = useIsBetConfirmedConnected(betCode);
  const hasEarlyBets = useHighflyerStateSlice.hasEarlyBets(betCode);
  const isDealingIngProgress = useHighflyerStateSlice.isDealingInProgress(betCode);
  const remainingBalance = useHighflyerStateSlice.balance();
  return useMemo(() => {
    let isDisabled = false;
    const isLowBalance = remainingBalance < betMinLimit && !isBetConfirmed;
    if (isBetConfirmed) {
      isDisabled = true;
    }
    if (
      [GameStatus.Dealing, GameStatus.WaitForNextGame, GameStatus.Result].includes(currentStatus as GameStatus) &&
      !isDealingIngProgress
    ) {
      isDisabled = false;
    }
    if (hasEarlyBets) {
      isDisabled = true;
    }
    if (isLowBalance) {
      isDisabled = true;
    }
    return isDisabled;
  }, [currentStatus, betMinLimit, isBetConfirmed, remainingBalance, isDealingIngProgress, hasEarlyBets]);
};
